import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SFRTA_TracksRemovedFromServiceFormOReportSchema } from "./SFRTA_TracksRemovedFromServiceFormOReportSchema";

const ReportView = (props) => {
  let data = props.data ? props.data : {};

  let sectionsData = [{}, data, data.tbltest ? data.tbltest : [], [data], [data]];

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection
        title={
          <div>
            <div>{"TRACKS REMOVED FROM SERVICE - FORM O"}</div>
            <div style={{ fontWeight: 100 }}>{`(${props.title})`}</div>{" "}
          </div>
        }
        fontSizeOverride={"30px"}
        centerTitle={true}
      />
      <span className="spacer"></span>
      <table className="table-bordered">
        {SFRTA_TracksRemovedFromServiceFormOReportSchema.sections.map((section, i) => {
          return <ReportTableSectionRenderer key={i} section={section} rowsData={sectionsData[i]} />;
        })}
      </table>
    </div>
  );
};

const SFRTA_TracksRemovedFromServiceFormOReport = (props) => <ReportView {...props} />;

export default SFRTA_TracksRemovedFromServiceFormOReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/TracksRemovedFromServiceFormO/index.jsx